import type { SVGProps } from 'react';

const SvgInformationCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 18" {...props}>
    <path
      fill={props.color}
      fillRule="evenodd"
      d="M9 18A9 9 0 1 0 9 0a9 9 0 0 0 0 18zm1-14-.408 6.592H8.408L8 4zm-.04 9.447H8.054V11.54H9.96z"
      clipRule="evenodd"
    />
  </svg>
);

export default SvgInformationCircle;
